// Providers a community report can name, split by item type.
//
// Shared by the public report form and the admin review drawer so a report can
// be corrected to any value the form could have produced - and to no others.

export interface ReportProviderOption {
    value: string;
    label: string;
}

export const AUTOGRAPH_PROVIDERS: readonly ReportProviderOption[] = [
    { value: 'PSA', label: 'PSA' },
    { value: 'BECKETT', label: 'Beckett' },
    { value: 'JSA', label: 'JSA' },
    { value: 'ACOA', label: 'ACOA' },
    { value: 'FANATICS', label: 'Fanatics' },
    { value: 'PANINI', label: 'Panini' },
    { value: 'UPPERDECK', label: 'Upper Deck' },
    { value: 'GOAT', label: 'GOAT Authentics' },
    { value: 'TRISTAR', label: 'Tristar' },
    { value: 'CELEBRITY_AUTHENTICS', label: 'Celebrity Authentics' },
    { value: 'ONLINE_AUTHENTICS', label: 'OnlineAuthentics' },
    { value: 'SWAU', label: 'SWAU' },
    { value: 'GRAD', label: 'Grad Authentication' },
    { value: 'MLB', label: 'MLB Authentication' },
    { value: 'OTHER', label: 'Other/Unknown' },
];

export const CARD_PROVIDERS: readonly ReportProviderOption[] = [
    { value: 'PSA_CARD', label: 'PSA Cards' },
    { value: 'PSA_VIDEO_GAMES', label: 'PSA Video Games' },
    { value: 'BECKETT_GRADING', label: 'Beckett Grading' },
    { value: 'CGC_CARDS', label: 'CGC Cards' },
    { value: 'CGC_COMICS', label: 'CGC Comics' },
    { value: 'CGC_VIDEO_GAMES', label: 'CGC Video Games' },
    { value: 'CGC_HOME_VIDEO', label: 'CGC Home Video' },
    { value: 'CSG', label: 'CSG' },
    { value: 'SGC_GRADING', label: 'SGC Grading' },
    { value: 'TAG_GRADING', label: 'TAG Grading' },
    { value: 'AMG', label: 'AMG' },
    { value: 'MBA', label: 'MBA' },
    { value: 'OTHER', label: 'Other/Unknown' },
];

export function reportProvidersFor(itemType: 'autograph' | 'card'): readonly ReportProviderOption[] {
    return itemType === 'card' ? CARD_PROVIDERS : AUTOGRAPH_PROVIDERS;
}
